import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export type StatusInfoRole = 'status' | 'alert' | null; // null will remove status info
export enum StatusInfoModifier {
  CENTER = 'center',
  INVISIBLE = 'invisible',
  MARGIN_BOTTOM = 'margin-bottom',
  MARGIN_BOTTOM_LARGE = 'margin-bottom-large',
  MARGIN_LEFT_LARGE = 'margin-left-large',
  PADDING_TOP = 'padding-top',
  PADDING = 'padding',
  RED = 'red',
  RED_APPLICATION = 'red-application',
  RIGHT = 'right',
  ALIGN_LEFT = 'align-left',
}
export type StatusInfoDataFormStatus = 'sending' | 'fail' | 'success' | 'forwarding';

export type StatusInfo = {
  role?: StatusInfoRole;
  modifier?: Modifier<StatusInfoModifier>;
  dataFormStatus?: StatusInfoDataFormStatus;
};

/**
 * Component to Render small Error Info.
 */
export function StatusInfo({ modifier, role = 'status', children, dataFormStatus }: PropsWithChildren<StatusInfo>) {
  return (
    <div
      className={bem('status-info', modifier)}
      role={role === null ? undefined : role}
      data-form-status={dataFormStatus}
    >
      {children}
    </div>
  );
}
